<template>
    <v-app>
        <app-navigation></app-navigation>
        <v-content transition="slide-x-transition">
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
import AppNavigation from '@/components/AppNavigation';
import Vue from 'vue';
import VueFbCustomerChat from 'vue-fb-customer-chat';

Vue.use(VueFbCustomerChat, {
    page_id: '1988616244718642', //  change 'null' to your Facebook Page ID,
    theme_color: '#BC1212', // theme color in HEX
    locale: 'es-MX',
    logged_in_greeting: 'Hola, ¿podemos ayudarte con algo?',
    logged_out_greeting: 'Hola, ¿podemos ayudarte con algo?'
});

export default {
    name: 'App',
    data: () => ({}),
    components: {
        AppNavigation
    }
};
</script>

<style>
.main-layout {
    width: 100%;
    height: 100%;
}
</style>
